exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.content.applicant-content ul.app-buttons{margin-bottom:0}input.search_input{width:73%!important}.content.applicant-content ul.app-buttons{display:flex;flex-direction:row}.content.applicant-content ul.app-buttons li.active-applications,.content.applicant-content ul.app-buttons li.archived-applications{width:47%;border-bottom:1px solid #ccc}.content.applicant-content ul.app-buttons li.active-applications.active,.content.applicant-content ul.app-buttons li.archived-applications.active{border-bottom:none}.content.applicant-content ul.app-buttons li.spacer{margin:0;flex:1;border-bottom:1px solid #ccc}.content.applicant-content .full-content{border-top:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/applications/applications.css
// module id = 747
// module chunks = 0